import { useNavigate } from 'react-router-dom';
import { useAuditStore } from '../../stores/useAuditStore';
import { useOnboardingStore } from '../../stores/useOnboardingStore';
import { useProcessingStore } from '../../stores/useProcessingStore';
import { useQuestionnaireStore } from '../../stores/useQuestionnaireStore';
import { useReportStore } from '../../stores/useReportStore';

/**
 * Returns a handler that resets all workflow stores and starts the onboarding
 * flow at `/sign`. Shared by the landing CTAs and the nav button.
 *
 * Users who have already signed are moved straight on to `/connect` by
 * SignView's own status check, so this doesn't make anyone sign twice.
 */
export function useStartAudit() {
  const navigate = useNavigate();
  return () => {
    useAuditStore.getState().reset();
    useOnboardingStore.getState().reset();
    useProcessingStore.getState().reset();
    useQuestionnaireStore.getState().reset();
    useReportStore.getState().setReportData(null as never);
    // The stores are in-memory, but the chat ids survive in sessionStorage.
    // A fresh start must drop them: /collect would otherwise adopt the OLD
    // chat, hit the one-shot 409 (its data was already collected), and
    // /processing would bounce to the previous run's report instead of
    // starting a new audit.
    try {
      sessionStorage.removeItem('analysis_chat_id');
      sessionStorage.removeItem('collect_chat_id');
    } catch { /* private mode */ }
    navigate('/sign');
  };
}
